import { EventEmitter, Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class MapToolBarService{

    toggleMeasureEvent: EventEmitter<any> = new EventEmitter()
    updateProjectEvent: EventEmitter<any> = new EventEmitter()
    exportGeoJSONEvent: EventEmitter<any> = new EventEmitter()

    toggleMeasure(measureAction: any){
        if (!measureAction) {
            this.toggleMeasureEvent.emit({measureAction: null});
        }
        else {
            this.toggleMeasureEvent.emit({measureAction: measureAction});
        }
    }

    private updateProjectSubject = new Subject<void>();
    updateProjectEvent2 = this.updateProjectSubject.asObservable();

    updateProject2() {
        this.updateProjectSubject.next();
    }

    updateProject() {
        this.updateProjectEvent.emit();
    }

    exportGeoJSON() {
        this.exportGeoJSONEvent.emit(true);
    }
}
